import { render, staticRenderFns } from "./statistic_salesman.vue?vue&type=template&id=f1882e24&scoped=true"
import script from "./statistic_salesman.vue?vue&type=script&lang=js"
export * from "./statistic_salesman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1882e24",
  null
  
)

export default component.exports